import { getDate } from "components/collections/util/format";
import l from "components/util/l";

const ColumnTypes = {
  STRING: "string",
  FLOAT: "float",
  FILE: "file",
  DATE: "date",
  TIME: "time",
  DATE_TIME: "datetime",
  ENUM: "enum",
  COLLECTION: "collection",
  BOOLEAN: "boolean",
  OBJECT: "object",
  USER: "user",
  LOCATION: "location"
};

const GroupedColumnTypes = [
  {
    label: "Básicos%CA117",
    types: [
      ColumnTypes.STRING,
      ColumnTypes.FLOAT,
      ColumnTypes.DATE,
      ColumnTypes.FILE,
      ColumnTypes.ENUM,
    ]
  }, 
  {
    label: "Específicos%CA120",
    types: [
       ColumnTypes.TIME,
      ColumnTypes.DATE_TIME,
      ColumnTypes.BOOLEAN,
      ColumnTypes.USER,
      ColumnTypes.LOCATION,
    ]
  },
   {
    label: "Referencias%CA119",
    types: [
      
      ColumnTypes.COLLECTION,
    ]
  },
]

const ColumnTypeLabels = {
  [ColumnTypes.STRING]: "Texto%CA121",
  [ColumnTypes.FLOAT]: "Número%CA122",
  [ColumnTypes.FILE]: "Archivo%CA123",
  [ColumnTypes.DATE]: "Fecha%CA124",
  [ColumnTypes.TIME]: "Hora%CA125",
  [ColumnTypes.DATE_TIME]: "Fecha y hora%CA126",
  [ColumnTypes.ENUM]: "Catálogo (Opciones fijas)%CA127",
  [ColumnTypes.COLLECTION]: "Referencia a tabla (Llave foránea)%CA128",
  [ColumnTypes.BOOLEAN]: "Booleano (si/no)%CA129",
  [ColumnTypes.OBJECT]: "Objeto%CA130",
  [ColumnTypes.USER]: "Usuario%CA131",
  [ColumnTypes.LOCATION]: "Ubicación%CA132",
}

const ColumnTypeIcons = {
  [ColumnTypes.STRING]: "fas fa-align-left",
  [ColumnTypes.FLOAT]: "fas fa-hashtag",
  [ColumnTypes.FILE]: "fas fa-file",
  [ColumnTypes.DATE]: "fas fa-calendar-alt",
  [ColumnTypes.TIME]: "fas fa-clock",
  [ColumnTypes.DATE_TIME]: "fas fa-calendar",
  [ColumnTypes.ENUM]: "fas fa-list",
  [ColumnTypes.COLLECTION]: "fas fa-table",
  [ColumnTypes.BOOLEAN]: "fas fa-check-square",
  [ColumnTypes.OBJECT]: "fas fa-cube",
  [ColumnTypes.USER]: "fas fa-user",
  [ColumnTypes.LOCATION]: "fas fa-map-marker-alt",
}

const parseExportData = (collections, column, data) => {
  try {
    
    const collection = collections[column.structure?.collection_id];

    switch (column.type) {
      case ColumnTypes.STRING:
        return data;
      case ColumnTypes.ENUM:
        return data;
      case ColumnTypes.FLOAT:
        return parseFloat(data);
      case ColumnTypes.BOOLEAN:
        return data;
      case ColumnTypes.DATE:
        return getDate(data, "YYYY-MM-DD");
      case ColumnTypes.DATE_TIME:
        return getDate(data, "YYYY-MM-DD HH:mm:ss");
      case ColumnTypes.TIME:
        return data;
      case ColumnTypes.COLLECTION:
        if (typeof data == "object" && !Array.isArray(data))
          return data[collection?.schema?.primary_key] ?? "";
        return data?.toString() ?? "";
      case ColumnTypes.FILE:
        return data.url;
      default:
        return data;
    }

  }
  catch (e) {
    return data;
  }
}

const parseSuggestionType = (type) => {
  switch (type) {
    case "string": return "string";
    case "text": return "string";
    case "date": return "date";
    case "datetime": return "datetime";
    case "time": return "time";
    case "file": return "file";
    case "select": return "enum";
    case "checkbox": return "boolean";
    case "number": return "number";
    default: return "string";
  }
}

const parseRowByColumn = (row, columns) => {

  let newRow = {};

  Object.keys(row).forEach((key) => {
    const column = columns.find((column) => column.name == key);
    if (column) newRow[key] = parseCellByColumn(row[key], column);
  });

  return newRow;

}

const parseCellByColumn = (cell, column) => {

  let value = null;

  switch (column.type) {

    case ColumnTypes.FLOAT:
      try {
        value = parseFloat(cell);
        if (isNaN(cell)) value = null;
      } catch (e) { }
      break;

    case ColumnTypes.DATE:
      try {
        value = getDate(cell, "iso");
      } catch (e) { }
      break;

    case ColumnTypes.BOOLEAN:
      try {
        if (typeof cell == "boolean") {
          value = cell;
        }
        else if (typeof cell == "number") {
          if (cell == 1) value = true;
          else if (cell == 0) value = false;
          else value = null;
        }
        else if (typeof cell == "string") {
          if (["true", "1", "yes", "s", "si", "verdadero"].includes(cell.toLowerCase())) value = true;
          else if (["false", "0", "no", "n", "f", "falso", ""].includes(cell.toLowerCase())) value = false;
          else value = null;
        }
        else {
          value = null;
        }
      } catch (e) { }
      break;

    case ColumnTypes.FILE:
      try {

        if (typeof cell == "object") value = cell;
        else if (cell?.startsWith("http")) value = { url: cell };
        else if (!isNaN(cell)) value = { id: parseInt(cell) };
        else value = JSON.parse(cell);

        if (isNaN(cell?.id)) value = null;

      } catch (e) { }
      break;

    case ColumnTypes.DATE_TIME:
      try {
        value = getDate(cell, "iso");
      } catch (e) { }
      break;

    default:
      try {
        value = cell.toString();
      } catch (e) { }
      break;

  }

  return value;

}

const getSelectTypes = () => {
  const keys = Object.keys(ColumnTypes).filter((key) => key !== "OBJECT");
  return keys.map((key) => {
    return ColumnTypes[key]
  });
}

const parseDatatypes = (structure, rawValues, appDatatypes = []) => {

  // Wrappeer for values
  const rule1 = (structure, rawValues, _) => {

    if (typeof rawValues === "object" && !Array.isArray(rawValues))
      return { structure, rawValues: [rawValues] };

    return { structure, rawValues };

  }

  // Wrapper for structure
  const rule2 = (structure, rawValues, _) => {

    if (typeof structure === "object" && !Array.isArray(structure)) {

      let nativeDataTypes = Object.keys(ColumnTypes)
        .map((key) => ColumnTypes[key])
        .filter((key) => key != ColumnTypes.OBJECT);

      if (structure.type != ColumnTypes.OBJECT && nativeDataTypes.includes(structure.type))
        return { structure: [structure], rawValues };

    }

    return { structure, rawValues };

  }

  // Wrapper for structure datatype
  const rule3 = (structure, rawValues, datatypes) => {

    if (typeof structure === "object" && !Array.isArray(structure)) {

      let nativeDataTypes = Object.keys(ColumnTypes)
        .map((key) => ColumnTypes[key])
        .filter((key) => key != ColumnTypes.OBJECT);

      if (structure.type == ColumnTypes.OBJECT)
        return { structure: structure.structure ?? [structure], rawValues };

      if (!nativeDataTypes.includes(structure.type)) {
        let datatype = datatypes?.find(dt => dt.name == structure?.type);
        if (datatype) return { structure: [{ ...structure, type: ColumnTypes.OBJECT, structure: datatype.structure }], rawValues };
      }

    }
    else {

      let nativeDataTypes = Object.keys(ColumnTypes)
        .map((key) => ColumnTypes[key])
        .filter((key) => key != ColumnTypes.OBJECT);

      structure = structure.map((column) => {

        if (!nativeDataTypes.includes(structure.type)) {
          let datatype = datatypes?.find(dt => dt.name == column?.type);
          if (datatype) return { ...column, type: ColumnTypes.OBJECT, structure: datatype.structure };
        }

        return column;

      });

    }

    return { structure, rawValues };

  }

  // Wrapper for rawValues which keys are not in structure
  const rule4 = (structure, rawValues, _) => {

    if (Array.isArray(structure) && Array.isArray(rawValues)) {

      let newRawValues = rawValues.map((row) => {

        let newRow = {};
        structure.forEach((column) => {
          if (!row[column.name]) {
            newRow[column.name] = row;
          }
        });

        return Object.assign({}, newRow, row);

      });

      return { structure, rawValues: newRawValues };

    }

    return { structure, rawValues };

  }

  let newRawValues = rawValues;
  let newStructure = structure;

  // Apply rules
  ({ structure: newStructure, rawValues: newRawValues } = rule1(newStructure, newRawValues, appDatatypes));
  ({ structure: newStructure, rawValues: newRawValues } = rule2(newStructure, newRawValues, appDatatypes));
  ({ structure: newStructure, rawValues: newRawValues } = rule3(newStructure, newRawValues, appDatatypes));
  // ({ structure: newStructure, rawValues: newRawValues } = rule4(newStructure, newRawValues, appDatatypes));

  // Wrapper for rawValues 
  if (newRawValues)
    newRawValues = newRawValues.map((row) => ({ data: row }));

  if (!Array.isArray(newStructure)) newStructure = [newStructure];

  return { newStructure, newRawValues };

}

export {
  ColumnTypes,
  GroupedColumnTypes,
  ColumnTypeLabels,
  ColumnTypeIcons,
  getSelectTypes,
  parseExportData,
  parseSuggestionType,
  parseRowByColumn,
  parseCellByColumn,
  parseDatatypes
}